import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { Outlet, useOutletContext } from 'react-router-dom';
import TabsNavigation from './TabsNavigation';
const Layout = () => {
    const { user } = useOutletContext();
    return (_jsxs(_Fragment, { children: [_jsx(TabsNavigation, {}), _jsx(Stack, { flexGrow: "1", sx: { boxShadow: ({ boxShadow }) => boxShadow, mt: 0.5, p: 4, pt: 6 }, children: _jsx(Outlet, { context: { user } }) })] }));
};
export default Layout;
